import getStore from '../store/store';
import { State } from '../store/schema/State';

export function getStoreState(): State {
    return getStore().state;
}
